import { __awaiter } from "tslib";
import { FilesetResolver, InteractiveSegmenter, } from "@mediapipe/tasks-vision";
export class ImageSegmenter {
    constructor(assetsPath) {
        this.assetsPath = assetsPath;
        this.segmenter = null;
    }
    get loaded() {
        return this.segmenter !== null;
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.segmenter)
                return;
            const vision = yield FilesetResolver.forVisionTasks(`${this.assetsPath}`);
            this.segmenter = yield InteractiveSegmenter.createFromOptions(vision, {
                outputCategoryMask: true,
                outputConfidenceMasks: false,
                baseOptions: {
                    modelAssetPath: `${this.assetsPath}/magic_touch.tflite`,
                },
            });
        });
    }
    segment(source, keypoint) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.segment)
                throw new Error("Image Segmenter has not been initialized");
            const width = source.width;
            const height = source.height;
            // suppose the middle point contains our object
            keypoint !== null && keypoint !== void 0 ? keypoint : (keypoint = { x: 0.5, y: 0.5 });
            const { categoryMask: mask } = yield new Promise((resolve) => this.segmenter.segment(source, { keypoint }, resolve));
            const data = mask.getAsFloat32Array();
            const cnv = document.createElement("canvas");
            cnv.width = width;
            cnv.height = height;
            const ctx = cnv.getContext("2d");
            ctx.drawImage(source, 0, 0);
            let minX = width;
            let minY = height;
            let maxX = 0;
            let maxY = 0;
            const imgData = ctx.getImageData(0, 0, width, height);
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    const index = y * width + x;
                    if (data[index] === 1) {
                        // Set alpha channel to 0 (fully transparent)
                        imgData.data[index * 4 + 3] = 0;
                    }
                    else {
                        if (x < minX)
                            minX = x;
                        if (y < minY)
                            minY = y;
                        if (x > maxX)
                            maxX = x;
                        if (y > maxY)
                            maxY = y;
                    }
                }
            }
            ctx.putImageData(imgData, 0, 0);
            const croppedWidth = maxX - minX + 1;
            const croppedHeight = maxY - minY + 1;
            const croppedCanvas = document.createElement("canvas");
            croppedCanvas.width = croppedWidth;
            croppedCanvas.height = croppedHeight;
            const croppedCtx = croppedCanvas.getContext("2d");
            // Draw the cropped area from the original canvas to the new cropped canvas
            croppedCtx.drawImage(cnv, minX, minY, croppedWidth, croppedHeight, 0, 0, croppedWidth, croppedHeight);
            return croppedCanvas.toDataURL();
        });
    }
}
